var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MembersList/MembersListInner.jinja"] = require( "front/components/MembersList/MembersListInner.jinja" );
dependencies["front/components/MembersList/MembersListAvailability.jinja"] = require( "front/components/MembersList/MembersListAvailability.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MembersList/MembersList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MembersList/MembersList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MembersList/MembersListInner.jinja", false, "assets/app/front/components/MembersList/MembersList.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MembersListInner")) {
var t_7 = t_4.MembersListInner;
} else {
cb(new Error("cannot import 'MembersListInner'")); return;
}
context.setVariable("MembersListInner", t_7);
output += "\n";
env.getTemplate("front/components/MembersList/MembersListAvailability.jinja", false, "assets/app/front/components/MembersList/MembersList.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "MembersListAvailability")) {
var t_11 = t_8.MembersListAvailability;
} else {
cb(new Error("cannot import 'MembersListAvailability'")); return;
}
context.setVariable("MembersListAvailability", t_11);
output += "\n\n";
var macro_t_12 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_13 = "";t_13 += "\n    <div class=\"MembersList\" data-limit-featured=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"limit")),"featured"), env.opts.autoescape);
t_13 += "\" data-limit-searched=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"limit")),"searched"), env.opts.autoescape);
t_13 += "\">\n        <div class=\"MembersList-wrapper\">\n            <div class=\"MembersListInner MembersListInner--";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"type"), env.opts.autoescape);
t_13 += "\">\n                ";
t_13 += runtime.suppressValue((lineno = 9, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MembersListInner"), "MembersListInner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"),"limit": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"limit")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"type")),"tp": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"type"),"page": 0})])), env.opts.autoescape);
t_13 += "\n            </div>\n        </div>\n\n        <div ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasMore")) {
t_13 += "style=\"display:none\"";
;
}
t_13 += " class=\"MembersList-showMoreButton\">\n            <button>Show More</button>\n        </div>\n\n        <div class=\"MembersList-membersBanner\">\n            ";
t_13 += runtime.suppressValue((lineno = 18, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MembersListAvailability"), "MembersListAvailability", context, [])), env.opts.autoescape);
t_13 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_13);
});
context.addExport("MembersList");
context.setVariable("MembersList", macro_t_12);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MembersList/MembersList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MembersList/MembersList.jinja
// module id = 504
// module chunks = 0